import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { BlockingLicenceNotification } from './BlockingLicenceNotification';
import { BlockingNotificationType, NotificationType } from 'src_server/trpc/types/accountModel/accountResponse';
import { BlockingTermsNotification } from './BlockingTermsNotification';
import { BlockingContactPreferencesNotification } from './BlockingContactPreferencesNotification';
import { PrivacyPolicyNotification } from './PrivacyPolicyNotification';
import { BlockingKycDepositRestrictionNotification } from './BlockingKycDepositRestrictionNotification';
import { BlockingRingedfencedFundsNotification } from './BlockingRingfencedFundsNotification';
import { useCommon } from 'src/domains/common/Common';
import { AppPlayersState } from 'src/domains/players/state/AppPlayers.state';
import { BlockingRTPNotification } from './BlockingRTPNotification';

interface BlockingNotificationsPropsType {
    blockingNotificationType: NotificationType;
}

export const BlockingNotifications = observer(
    'BlockingNotifications',
    ({ blockingNotificationType }: BlockingNotificationsPropsType): JSX.Element | null => {
        const common = useCommon();
        const { blockingNotificationsState } = AppPlayersState.get(common);

        switch (blockingNotificationType) {
            case BlockingNotificationType.CHANGE_OF_LICENSE:
                return (
                    <BlockingLicenceNotification
                        onConfirm={blockingNotificationsState.handleConfirmNewLicenceNotification}
                    />
                );
            case BlockingNotificationType.PRIVACY_UPDATE:
                return (
                    <PrivacyPolicyNotification onConfirm={blockingNotificationsState.handleConfirmNewPrivacyPolicy} />
                );
            case BlockingNotificationType.TERMS_UPDATE:
                return <BlockingTermsNotification onConfirm={blockingNotificationsState.handleConfirmNewTerms} />;
            case BlockingNotificationType.KYC_DEPOSIT_RESTRICTION:
                //for operators with idMission: false
                return (
                    <BlockingKycDepositRestrictionNotification
                        onConfirm={blockingNotificationsState.handleConfirmKycDepositRestrictionNotification}
                    />
                );
            case BlockingNotificationType.CONTACT_PREFERENCES:
                return (
                    <BlockingContactPreferencesNotification
                        onConfirm={blockingNotificationsState.handleConfirmContactPreferences}
                    />
                );
            case BlockingNotificationType.RINGFENCED_FUNDS_UPDATE:
                return (
                    <BlockingRingedfencedFundsNotification
                        onConfirm={blockingNotificationsState.handleConfirmRingfencedfunds}
                    />
                );
            case BlockingNotificationType.RTP_UPDATE:
                return <BlockingRTPNotification onConfirm={blockingNotificationsState.handleConfirmRTPNotification} />;
            default:
                return null;
        }
    }
);
